export function shuffle(arr) {
	return arr.map((a) => [Math.random(),a]).sort((a,b) => a[0]-b[0]).map((a) => a[1]);
}

export function tally(arr) {
	const t = {};
	arr.forEach(result => {
		if (!t[result]) t[result] = 1;
    else t[result] = t[result] + 1;
	});

	return +Object.keys(t).sort((a, b) =>  t[b] - t[a])[0];
}

/**
 * Returns an array with arrays of the given size.
 *
 * @param myArray {Array} Array to split
 * @param chunkSize {Integer} Size of every group
 */
export function chunkArray(myArray, chunk_size) {
	const results = [];
	
	while (myArray.length) {
			results.push(myArray.splice(0, chunk_size));
	}
	
	return results;
}

export function chunk(array, size) {
  return array.reduce((chunks, item, i) => {
    if (i % size === 0) {
      chunks.push([item]);
    } else {  
      chunks[chunks.length - 1].push(item);
    }
    return chunks;
  }, []);
}